module.exports = __webpack_public_path__ + "img/usa.2622117d.svg";